const mainPages = ['Index', 'Quiz', 'PasteList']

export default mainPages



// WEBPACK FOOTER //
// ./src/router/mainPages.js